export default class Subtitles {
  constructor({ videoElement, language, id }) {
    this.videoElement = videoElement;
    this.language = language;
    this.id = id;

    this.init();
  }

  init() {
    if (this.videoElement && this.videoElement.textTracks.length) {
      this.selectTrack();
      this.switchMode();
      this.createSubtitleNode();

      this.onResize = () => this.positionSubtitles();
      window.addEventListener('resize', this.onResize);

      this.setSubtitlesStyle();

      this.renderSubtitles();

      this.track.oncuechange = () => this.renderSubtitles();
    }
  }

  selectTrack() {
    if (
      this.language &&
      this.videoElement &&
      typeof this.videoElement.textTracks === Array
    ) {
      this.track =
        this.videoElement?.textTracks?.find(
          track => track.language === this.language,
        ) || this.videoElement?.textTracks[0];
    } else {
      this.track = this.videoElement?.textTracks[0];
    }
  }

  switchMode() {
    if (this.track?.mode !== 'hidden') {
      this.oldMode = this.track.mode;
      this.track.mode = 'hidden';
      this.track.addEventListener('modechange', e => console.log(e));
    }
  }

  createSubtitleNode() {
    const { parentNode } = this.videoElement;
    this.subtitleNode = document.createElement('div');
    this.subtitleNode.style.pointerEvents = 'none';
    parentNode.append(this.subtitleNode);
    this.positionSubtitles();
  }

  positionSubtitles(isUpdate, controlsElement) {
    if (isUpdate) {
      this.subtitleNode.style.transitionDuration = '0.15s';
    } else {
      this.subtitleNode.style.transitionDuration = '0s';
    }

    if (controlsElement) {
      this.objectBelow = controlsElement;
    }
    
    const belowOffset =
      this.objectBelow && this.objectBelow.offsetTop
        ? this.videoElement.offsetTop +
          this.videoElement.offsetHeight -
          this.objectBelow.offsetTop
        : 0;
    this.subtitleNode.style.position = 'absolute';
    this.subtitleNode.style.width = `${0.7 * this.videoElement.offsetWidth}px`;
    
    //Position vertical
    let top;
    const cue = this.track.activeCues?.[0];
    const defaultTop =
      this.videoElement.offsetTop +
      this.videoElement.offsetHeight -
      this.subtitleNode.offsetHeight -
      (belowOffset || 10);

    if (cue) {
      const { line } = cue;

      if (typeof line === 'number') {
        const lineAsPercent = line;

        if (lineAsPercent >= 80 && belowOffset > 0) {
          // Subtítulo está en el fondo y los controles están visibles
          top = defaultTop;
        } else {
          // Posiciona los subs usando el porcentaje normalmente
          top =
            this.videoElement.offsetTop +
            (lineAsPercent / 100) * this.videoElement.offsetHeight;
        }
      } else if (line === 'auto') {
        // Envia los subs al fondo
        top = defaultTop;
      } else {
        top = defaultTop;
      }
    } else {
      //fallback
      top = this.videoElement.offsetTop + 0.9 * this.videoElement.offsetHeight;
    }
    this.subtitleNode.style.top = `${top}px`;
    this.subtitleNode.style.left = `${0.15 * this.videoElement.offsetWidth}px`;
    this.subtitleNode.style.textAlign = 'center';
    this.subtitleNode.style.fontSize = `${0.06 *
      this.videoElement.offsetHeight}px`;
    this.subtitleNode.style.lineHeight = `${0.08 *
      this.videoElement.offsetHeight}px`;
  }

  setSubtitlesStyle() {
    if (this.id) {
      this.subtitleNode.setAttribute('id', this.id);
    } else {
      this.subtitleNode.setAttribute('id', 'subtitleNode');
      this.subtitleNode.style.color = 'white';
      this.subtitleNode.style.textShadow =
        '0px 2px 2px black,2px 0px 2px black,-2px 0px 2px black, 0px -2px 2px black';
      this.subtitleNode.style.fontSize = '4rem';
      this.subtitleNode.style.lineHeight = '4.5rem';
    }
  }

  renderSubtitles() {
    if (this.track.mode === 'showing') {
      this.oldMode = this.track.mode;
      this.track.mode = 'hidden';
      this.paintCues();
      this.positionSubtitles();
    } else if (this.oldMode === 'showing') {
      this.paintCues();
      this.positionSubtitles();
    }
  }

  paintCues() {
    if (this.track.activeCues?.length > 0) {
      this.subtitleNode.innerHTML = [...this.track.activeCues]
        .flatMap(item => item.text.split('\n'))
        .join('<br/>');
    } else {
      this.subtitleNode.innerHTML = null;
    }
  }

  changeMode(mode) {
    this.oldMode = mode;
    if (this.subtitleNode) {
      this.subtitleNode.remove();
    }
    this.init();
    /* if (mode === 'showing') {
    } */
  }

  reset() {
    this.subtitleNode.remove();
    window.removeEventListener('resize', this.onResize);
    this.track.oncuechange = null;
    this.track.mode = this.oldMode;
  }

  clean() {
    if (this.subtitleNode && this.track) {
      this.subtitleNode.remove();
      window.removeEventListener('resize', this.onResize);
      this.track.oncuechange = null;
      this.track.mode = this.oldMode;
    }
  }

  placeAbove(objectBelow) {
    this.objectBelow = objectBelow;
    if (this.videoElement && this.videoElement.textTracks.length) {
      this.positionSubtitles();
    }
  }

  placeBelow(objectAbove) {
    this.objectAbove = objectAbove;
    if (this.videoElement && this.videoElement.textTracks.length) {
      this.positionSubtitles();
    }
  }
}
